import React, { useEffect, useState, Fragment, useRef } from 'react';
import { makeStyles,withStyles } from '@material-ui/core/styles';
import { PageHeader } from '../../../../Common';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import TextField from '@material-ui/core/TextField';
import '../../../Common/Table/table.css';
import groupService from '../../../Group/services';
import divisionService from '../../../Devision/services';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import services from '../services';
import MaterialTable from 'material-table';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import CardMedia from '@material-ui/core/CardMedia';

import MenuItem from '@material-ui/core/MenuItem';
const screenCode = 'CHECKROLLWEIGHMENTREPORT';

const useStyles = makeStyles((theme) => ({
    root: {
      minWidth: 275,
      fontSize: 10,
    },
    title: {
      fontSize: 12,
    },
    pos: {
      marginBottom: 12,
    },
    media: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
  }));


  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export function ImageRecognitionReport(props) {
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [divisions, setDivisions] = useState();
    const [fields, setFields] = useState();
    const [sessions, setSessions] = useState({});
    const [reportData, setReportData] = useState([]);
    
    const [open, setOpen] = React.useState(false);
    const [currentViewingImage, setCurrentViewingImage] = React.useState('');
    const [requiredFile, setRequiredFile] = React.useState("");


    async function handleClickOpen(rowData){
     setOpen(true);
      let result = await services.GetImageForView(rowData.employeeID+"_"+rowData.employeeImageCaptureID);//getImagesFromFileStream(rowData.employeeID+"_"+rowData.employeeImageCaptureID);
      setCurrentViewingImage(result);
    };
  
    const handleClose = () => {
      setOpen(false);
    };


  useEffect(() => {
    trackPromise(
      setGroupDropDownData()
    )
  }, []);

  async function getImagesFromFileStream(path) {
    const result = await services.GetImageForView(path);
    
  }

  async function setGroupDropDownData() {
    const result = await groupService.getGroupsForDropdown();
    setGroups(result);
  }
    async function getEsatesForDropDown(id) {
        const factoryList = await divisionService.getEstatesByGroupID(id);
        setEstates(factoryList);
    }

    async function GetDivisionForDropDown(id) {
        const routeList = await services.GetDivisionByEstateID(id);
        setDivisions(routeList);
    }

    async function getFeildsByCollectionPoint(id) {
        const fields = await services.GetAvialableFieldsForDropdown(id);
        setFields(fields);
    }


    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0",
            searchDate: new Date().toISOString().split('T')[0]
        }
    );
    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleGroupChange(target) {
        
          setSearchForm({
              ...searchForm,
              groupID: target.value,
              estateID: "0",
              divisionID: "0",
              fieldID: "0",
              sessionID: "0"
          });

          trackPromise(
            getEsatesForDropDown( target.value)
        )
    }

    function handleEstateChange(target) {

        setSearchForm({
            ...searchForm,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });

    }

    function handleDivisionChange(target) {

        setSearchForm({
            ...searchForm,
            divisionID: target.value,
            fieldID: "0",
            sessionID: "0"
        });
        let data = {
          groupID: searchForm.groupID,
          estateID:searchForm.estateID ,
          divisionID: target.value,
          fieldID: "0",
          searchDate:target.value
        };

     
        trackPromise(getFeildsByCollectionPoint(data));
    }

    function handleFieldChange(target) {
      
        setSearchForm({
            ...searchForm,
            fieldID: target.value,
            sessionID: "0"
        });
        trackPromise(getMobileSessions());
    }

    function handleSessionChange(target) {
       setSearchForm({
           ...searchForm,
           sessionID: target.value
          
       });
       let searchData = {
        mobileSessionID:target.value,
        searchDate:searchForm.searchDate
       }
       getReportData(searchData);

   }

   async function getReportData(searchData){
    const result = await services.GetReportData(searchData);
    setReportData(result);
   }


    async function getMobileSessions(data) {
        if (searchForm.searchDate !== "")
             await getMobileSessionsForDropDown(data);
    }

    async function getMobileSessionsForDropDown(data) {
        const selectedSessions = await services.GetMobileSessionsForWeighReport(data);
        setSessions(selectedSessions);
    }

    function handleDateChange (target) {
        setSearchForm({
            ...searchForm,
           searchDate:target.value
        });
        let data = {
          groupID: searchForm.groupID,
          estateID:searchForm.estateID ,
          divisionID: "0",
          fieldID: "0",
          sessionID: "0",
          searchDate:target.value
        };
        trackPromise(GetDivisionForDropDown(parseInt(target.value)), getMobileSessions(data));
      };

    return (
        <Fragment>
           <LoadingSpinerComponent />
        <Card className={classes.root}>
          <CardContent>
            <PageHeader
              title="Image Recognition Status Report"
              isButtonEnable={true}
              buttonText="Add Manual Leaf Entry"
              path="/manualLeafCollection" />

            <br/>
            <div>
            <form className={classes.root} noValidate autoComplete="off">
                <Grid container spacing={3}>
                <Grid item xs={3} >
                    <TextField
                      id="groupID"
                      select
                      fullWidth
                      label="Group"
                      value={searchForm.groupID}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group Name--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </TextField>
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      id="estateID"
                      select
                      fullWidth
                      label="Estate"
                      onChange={(e) => handleEstateChange(e.target)}
                      value={searchForm.estateID}

                    >
                      <MenuItem value="0">--Select Estate--</MenuItem>
                      {generateDropDownMenu(estates)}
                    </TextField>
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      id="searchDate"
                      type="date"
                      fullWidth
                      label="Date"
                      defaultValue="2017-05-24"
                      onChange={(e) => handleDateChange(e.target)}
                      value={searchForm.searchDate}
                    >
                      <MenuItem value="0">--Select Mobile Session--</MenuItem>
                      {generateDropDownMenu(fields)}
                    </TextField>
                  </Grid>
                
                </Grid>
              <Grid container spacing={3}>

               
                <Grid item xs={3}>
                  <TextField
                    id="divisionID"
                    select
                    fullWidth
                    label="Division"
                    onChange={(e) => handleDivisionChange(e.target)}
                    value={searchForm.divisionID}
                    
                  >
                    <MenuItem value="0">--Select Route Name--</MenuItem>
                    {generateDropDownMenu(divisions)}
                  </TextField>

                </Grid>

                <Grid item xs={3}>
                  <TextField
                    id="fieldID"
                    select
                    fullWidth
                    label="Feild"
                    onChange={(e) => handleFieldChange(e.target)}
                    value={searchForm.divisionID}
                   
                  >
                    <MenuItem value="0">--Select Feild--</MenuItem>
                    {generateDropDownMenu(fields)}
                  </TextField>

                </Grid>

                <Grid item xs={3}>
                  <TextField
                    id="sessionID"
                    select
                    fullWidth
                    label="Session"
                    onChange={(e) => handleSessionChange(e.target)}
                    value={searchForm.sessionID}
                   
                  >
                    <MenuItem value="0">--Select Mobile Session--</MenuItem>
                    {generateDropDownMenu(sessions)}
                  </TextField>
                </Grid>
              </Grid>
              
            </form>
            <div>
                <br/> <br/>
                <MaterialTable
                  title="Employee Image Recognition Status"

                  columns={[
                    { title: 'Employee Name', field: 'firstName', cellStyle:{ padding: '2px'}  },
                    { title: 'Card No', field: 'cardNumber', cellStyle:{ padding: '2px'}  },
                    { title: 'Status', field: 'status', lookup: { 'TRUE': 'Match', 'ISSUE': 'Mismatch',null:'Pending','AD':'Admin Approved' }, cellStyle:{ padding: '2px'}  }
                   
                  ]}
                  data={reportData}
                  actions={[
                    {
                      icon: 'visibility',
                      tooltip: 'Image View',
                      onClick: (event, rowData) =>handleClickOpen(rowData)
                    }
                  ]}
                  options={{
                    exportButton: true,
                    showTitle: false,
                    headerStyle: { backgroundColor: "#48B862", color: "white", textAlign: "center", height: '1%' },
                    cellStyle: {
                      width: '1%',
                      maxWidth:'1%'
                      },
                    columnResizable:true,
                    actionsColumnIndex: -1
                  }}
                />
              </div>
            </div>
          </CardContent>
          <CardActions>
         
          </CardActions>
        </Card>
       

        <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">{"Employee Image"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <Card className={classes.root}>
                <CardContent>
                  {currentViewingImage == null ?
                    <Typography>No Image</Typography>
                    :

                    <CardMedia
                      className={classes.media}
                      image={`data:image/jpeg;base64,${currentViewingImage}`}
                    />
                  }
                </CardContent>
                <CardActions>
                  
                </CardActions>
              </Card>
            </DialogContentText>
          </DialogContent>
          <DialogActions>

            <Button onClick={handleClose} color="primary">
              Close
          </Button>
          </DialogActions>
        </Dialog>
       
  </Fragment>
    )
}

